module.exports = __webpack_public_path__ + "media/MRI8C.482c5fb1.mp3";